import Keycloak from 'keycloak-js'

export const keycloak = Keycloak()

export const keycloakProviderInitConfig = {
  onLoad: 'login-required',
}

export function onKeycloakEvent(event) {
  switch (event) {
    case 'onReady':
      break
    case 'onInitError':
      break
    case 'onAuthSuccess':
      break
    case 'onAuthError':
      break
    case 'onAuthRefreshSuccess':
      break
    case 'onAuthRefreshError':
      break
    case 'onTokenExpired':
      break
    case 'onAuthLogout':
      break
  }
}

export function setKeycloakToken() {}
